module.exports = require("@floating-ui/react-dom");